/**
 * Return Visit Detection Hook
 * Phase R2: Detect when user returns after 24+ hours
 * NOTE: Pulse feature removed - this is now a simple noop stub
 */

"use client"

import { useState, useEffect } from "react"

const RETURN_THRESHOLD_MS = 24 * 60 * 60 * 1000 // 24 hours
const LAST_VISIT_KEY = "biziq_last_visit"

interface UseReturnVisitResult {
  isReturnVisit: boolean
  pulse: null
  isLoading: false
  dismissPulse: () => Promise<void>
  markPulseViewed: () => Promise<void>
}

export function useReturnVisit(): UseReturnVisitResult {
  const [isReturnVisit, setIsReturnVisit] = useState(false)

  // Check for return visit on mount
  useEffect(() => {
    if (typeof window === "undefined") return

    const lastVisit = localStorage.getItem(LAST_VISIT_KEY)
    const now = Date.now()

    if (lastVisit) {
      const lastVisitTime = Number.parseInt(lastVisit, 10)
      const timeSinceLastVisit = now - lastVisitTime

      if (timeSinceLastVisit >= RETURN_THRESHOLD_MS) {
        setIsReturnVisit(true)
      }
    }

    // Update last visit time
    localStorage.setItem(LAST_VISIT_KEY, now.toString())
  }, [])

  // Return noop stubs - pulse feature removed
  return {
    isReturnVisit,
    pulse: null,
    isLoading: false,
    dismissPulse: async () => {},
    markPulseViewed: async () => {},
  }
}
